import PaymentMethodTile from "./PaymentMethodTile";

export default PaymentMethodTile;
